export default __webpack_public_path__ + "static/media/provecho.aebfdec6.png";